import React from 'react';
import DataTableBody from "../components/DataTableBody";
export default function bodyRenderer(props) {
  var data = props.data,
      rowSelections = props.rowSelections,
      tableMetadata = props.tableMetadata,
      displayPreferences = props.displayPreferences,
      cellRenderers = props.cellRenderers,
      renderActions = props.renderActions,
      onRowClick = props.onRowClick,
      onRowSelect = props.onRowSelect,
      isLoading = props.isLoading,
      controlsColumnWidth = props.controlsColumnWidth,
      rowRenderer = props.rowRenderer,
      emptyRowText = props.emptyRowText,
      onPreviewClick = props.onPreviewClick,
      shouldRenderPreviewIcon = props.shouldRenderPreviewIcon,
      checkable = props.checkable,
      multi = props.multi,
      allowSelectionOnRowClick = props.allowSelectionOnRowClick,
      getTableRef = props.getTableRef;
  return React.createElement(DataTableBody, {
    data: data,
    rowSelections: rowSelections,
    tableMetadata: tableMetadata,
    displayPreferences: displayPreferences,
    cellRenderers: cellRenderers,
    renderActions: renderActions,
    onRowClick: onRowClick,
    onRowSelect: onRowSelect,
    isLoading: isLoading,
    controlsColumnWidth: controlsColumnWidth,
    rowRenderer: rowRenderer,
    emptyRowText: emptyRowText,
    onPreviewClick: onPreviewClick,
    shouldRenderPreviewIcon: shouldRenderPreviewIcon,
    checkable: checkable,
    multi: multi,
    allowSelectionOnRowClick: allowSelectionOnRowClick,
    getTableRef: getTableRef
  });
}